'use client';
import { useEffect } from 'react';
import { startDialogViewObserver } from '@/shared/libs/analytics/dialog-view-observer';

const DialogViewInitializer = () => {
  useEffect(() => {
    startDialogViewObserver();
  }, []);

  return null;
};

export { DialogViewInitializer };
